import * as z from 'zod';

const SharePhotoZodSchema = z.object({
  email: z
    .string({
      required_error: 'Adres email jest wymagany.',
    })
    .email({
      message: 'Niepoprawny adres email.',
    })
    .max(128, {
      message: 'Adres email jest zbyt długi.',
    }),
});

export default SharePhotoZodSchema;
